export function getItemId(id: number | string, receivedDate: Date) {
  return `${id}_${receivedDate.getTime()}`;
}
